/* ADD GROUPS */
export const LIST_REPORTB = "LIST_REPORTB"
export const LIST_REPORTB_SUCCESS = "LIST_REPORTB_SUCCESS"
export const LIST_REPORTB_CLEAN = "LIST_REPORTB_CLEAN"
export const LIST_REPORTB_ERROR = "LIST_REPORTB_ERROR"
